export const checkIsAmount = (amount) => {
  const amountValue = parseFloat(amount).toFixed(2);
  if (isNaN(amountValue)) {
    return "0.00";
  }
  return amountValue;
};
